import React from 'react'
import { Form, FormGroup, Input, Table, Label, Alert } from 'reactstrap'
import PropTypes from 'prop-types'
import PeriodicElement from '../periodicElement'
import { molarMass, findElements } from '../../../formulas/molarMassCalculator'

export default class AtomicMassForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            hasResult: false,
            hasError: false,
            error: ''
        }
    }

    handleChange = (e) => {
        const target = e.target
        let analyze = []
        if (target.value != null) {
            analyze = findElements(target.value) // Analyse des molécules pour récupérer les éléments analysés
        }
        this.props.formToState({ formula: target.value, analyze }) // Redux
        this.setState({ hasResult: false, hasError: false })
    }

    calculateAtomicMass = (e) => {
        try {
            e.preventDefault()
            e.stopPropagation()
            const result = molarMass(this.props.atomicMassValues.formula)
            this.props.formToState({ result }) // Redux
            this.setState({ hasResult: true, hasError: false })
        } catch (e) {
            this.setState({ hasError: true, error: "The chemical formula is not valid", hasResult: false })
        }
    }

    render() {
        return (
            <Form onSubmit={this.calculateAtomicMass}>
                <FormGroup>
                    <Label for="formula">Chemical Formula</Label>
                    <Input value={this.props.atomicMassValues.formula} required type="text" name="formula" id="formula" onChange={this.handleChange} placeholder="CaCO3" />
                </FormGroup>
                <Input type="submit" value="Calculate molar mass" className="custom-button" onClick={this.calculateAtomicMass} />
                <br />
                {/** Résultat */}
                {this.state.hasResult ?
                    <div>
                        <div className="formula-result text-center">
                            Molar mass of {this.props.atomicMassValues.formula} is {this.props.atomicMassValues.result.atomic_mass} g/mol
                        </div>
                        <br />
                        <Table responsive className="text-center">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Element</th>
                                    <th>Mass percentage</th>
                                </tr>
                                {this.props.atomicMassValues.result.elements.map((element, key) => {
                                    return (
                                        <tr key={key}>
                                            <td >{element.count}</td>
                                            <td>{element.symbol}</td>
                                            <td>{element.massPercentage} %</td>
                                        </tr>
                                    )
                                })}
                            </thead>
                        </Table>
                    </div>
                    : null}
                {/** Analyze */}
                {this.props.atomicMassValues.analyze && this.props.atomicMassValues.analyze.length > 0 ?
                    <ul className="flex-list">
                        {this.props.atomicMassValues.analyze.map((el, key) => {
                            return (
                                <li key={key} >
                                    <PeriodicElement element={el} />
                                </li>
                            )
                        })}
                    </ul>
                    : null}
                <br />
                {/** Erreur */}
                {this.state.hasError ?
                    <div className="text-center">
                        <Alert color="danger">
                            {this.state.error}
                        </Alert>
                    </div>
                    : null}
            </Form>
        )
    }
}
AtomicMassForm.propTypes = {
    formToState: PropTypes.func,
    atomicMassValues: PropTypes.shape({
        formula: PropTypes.string,
        analyze: PropTypes.arrayOf(PropTypes.object),
        result: PropTypes.shape({
            atomic_mass: PropTypes.number,
            elements: PropTypes.arrayOf(PropTypes.shape({
                symbol: PropTypes.string,
                atomic_mass: PropTypes.number,
                count: PropTypes.number,
                massPercentage: PropTypes.number
            }))
        })
    })
}
AtomicMassForm.defaultProps = {
    atomicMassValues: {
        formula: ''
    }
}